import React, {useRef} from 'react';
import {ListingImg, ListingImgContainer, ListingImgStyleProps} from '../../../../hooks/components/location/ListingImgStyles';
import {constructGalleryImageUrl} from "../../../../util/ConstructImageUrlUtil";

interface LocationListItemGalleryImageProps extends ListingImgStyleProps {
  galleryImageFileName: string;
  locationId: string;
}

const LocationListItemGalleryImage = (props: LocationListItemGalleryImageProps) => {
  const { galleryImageFileName, locationId } = props;
  const imageRef = useRef<HTMLImageElement>(null);
  const imageSrc = constructGalleryImageUrl(`${locationId}/${galleryImageFileName}`);

  return <ListingImgContainer {...props}>
    <ListingImg src={imageSrc} ref={imageRef} alt={'listing'} {...props} />
  </ListingImgContainer>
}

export default LocationListItemGalleryImage;
